import api from "@/services/api-service";
import { FLIGHT_CHECK_ACTION } from "@turizi/shared";


export default class ActionsController {

    static actions: Record<string, Function> = {
        [FLIGHT_CHECK_ACTION]: ActionsController.flightCheck
    }

    static async execute(action: string, value: any, context?: any) {
        const handler = ActionsController.actions[action];
        if (!handler) {
            return { data: null, error: `Action '${action}' not supported` };
        }
        try {
            return await handler(value, context);
        } catch (err: any) {
            return { data: null, error: err?.message || 'Failed to execute action' };
        }
    }

    // Trims down the context to the date
    static async flightCheck(value: any, context?: any) {
        if (!value || (value?.length < 6 || value?.length > 10)) {
            return Promise.resolve({ data: null });
        }
        const resolvedDate = context?.start || context?.end || context?.date || context?.start_day || context?.end_day;
        const payload: any = { value };
        if (resolvedDate) {
            payload.date = resolvedDate;
        }
        return api.actions.execute(FLIGHT_CHECK_ACTION, payload);
    }
}
